/*
 * iLOLA market links fix (Oct 6, 2026)
 * Why: on the Canada / UK / Australia stores (ilolatea.com/en-ca/, /en-gb/, /en-au/)
 * a number of links and data requests are written as plain "/products/...",
 * "/collections/..." etc. (hand-written links, and the "You May Also Enjoy" row).
 * Clicking one drops the visitor onto the US store (ilolatea.com) with US pricing.
 * This puts the market prefix back on those links and on the product-data requests.
 * It does nothing on the main US store. To remove: delete the <script> line for this
 * file in snippets/ilola-customer-state.liquid.
 */
(function () {
  if (window.__ilolaMarketLinks) return;
  window.__ilolaMarketLinks = true;
  var root = '';
  try { root = (window.Shopify && Shopify.routes && Shopify.routes.root) || ''; } catch (e) {}
  if (!root) {
    var m = /^\/([a-z]{2}-[a-z]{2})(\/|$)/i.exec(location.pathname);
    root = m ? '/' + m[1] + '/' : '/';
  }
  if (root === '/') return;
  var prefix = root.replace(/\/$/, '');
  var PAGE = /^\/(products|collections|pages|blogs|search|policies)(\/|\?|#|$)/;
  var DATA = /^\/(recommendations\/products\.json|collections\/[^\/?#]+\/products\.json|products\/[^\/?#]+\.js|search\/suggest(\.json)?)(\?|#|$)/;

  function localizePath(p) {
    if (typeof p !== 'string' || p.charAt(0) !== '/' || p.charAt(1) === '/') return p;
    if (p === prefix || p.indexOf(prefix + '/') === 0 || p.indexOf(prefix + '?') === 0 || p.indexOf(prefix + '#') === 0) return p;
    if (p === '/') return root;
    if (p.charAt(1) === '?' || p.charAt(1) === '#') return root + p.slice(1);
    if (PAGE.test(p)) return prefix + p;
    return p;
  }

  function fixLink(a) {
    try {
      var h = a.getAttribute('href');
      if (!h || h.charAt(0) !== '/') return;
      var n = localizePath(h);
      if (n !== h) a.setAttribute('href', n);
    } catch (e) {}
  }
  function fixForm(f) {
    try {
      var h = f.getAttribute('action');
      if (!h || h.charAt(0) !== '/') return;
      var n = localizePath(h);
      if (n !== h) f.setAttribute('action', n);
    } catch (e) {}
  }
  function scan() {
    try {
      var as = document.querySelectorAll('a[href^="/"]');
      for (var i = 0; i < as.length; i++) fixLink(as[i]);
      var fs = document.querySelectorAll('form[action^="/"]');
      for (var j = 0; j < fs.length; j++) fixForm(fs[j]);
    } catch (e) {}
  }
  var timer = null;
  function schedule() { if (timer) return; timer = setTimeout(function () { timer = null; scan(); }, 50); }

  /* Safety net: fix the link the instant it is pressed, even if it was added a moment ago. */
  ['mousedown', 'touchstart', 'click', 'auxclick', 'keydown'].forEach(function (ev) {
    document.addEventListener(ev, function (e) {
      try {
        var a = e.target && e.target.closest ? e.target.closest('a[href^="/"]') : null;
        if (a) fixLink(a);
      } catch (err) {}
    }, true);
  });

  /* Product / recommendation data requests: ask the current market, not the US one. */
  try {
    var of = window.fetch;
    if (typeof of === 'function') {
      window.fetch = function (input, init) {
        try {
          if (typeof input === 'string' && input.charAt(0) === '/' && DATA.test(input)) {
            input = prefix + input;
          } else if (input && typeof input === 'object' && input.url) {
            var u = new URL(input.url, location.href);
            if (u.origin === location.origin && DATA.test(u.pathname + u.search)) {
              input = new Request(prefix + u.pathname + u.search, input);
            }
          }
        } catch (e) {}
        return of.call(this, input, init);
      };
    }
  } catch (e) {}

  scan();
  document.addEventListener('DOMContentLoaded', scan);
  window.addEventListener('load', scan);
  try { new MutationObserver(schedule).observe(document.documentElement, { childList: true, subtree: true }); } catch (e) {}
})();